import { Component, OnInit, Input, AfterViewInit } from "@angular/core";

@Component({
  selector: "app-trust-pilot-reviews",
  templateUrl: "./trust-pilot-reviews.component.html",
  styleUrls: ["./trust-pilot-reviews.component.scss"],
})
export class TrustPilotReviewsComponent implements OnInit, AfterViewInit {
  @Input()
  lang;

  public selectedLanguage: string = "";

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const elements = Array.from(document.getElementsByClassName('trustpilot-widget'));

    if (elements) {
      elements.forEach(element => {
        (window as any).Trustpilot.loadFromElement(element);
      });
    }
  }
}
